import { useEffect, useState } from 'react';
import './MobOfflineBanner.css';

interface MobOfflineBannerProps {
  lastSyncAt?: Date | null;
}

export function MobOfflineBanner({ lastSyncAt }: MobOfflineBannerProps) {
  const [online, setOnline] = useState(
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (online) return null;

  const stamp = lastSyncAt
    ? lastSyncAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : '—';

  return (
    <div role="status" className="mob-offline">
      Offline — data as of {stamp}
    </div>
  );
}
